





























































// @ts-ignore
import TrackeData from '@/utils/trackData';
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Button } from 'ant-design-vue';

const user = namespace('user');

@Component({
  components: {
    AButton: Button,

  },
})
export default class GuessWant extends Vue {
[x: string]: any;

  @user.State('userInfo') userInfo: any;

  @user.Getter('getAccountStatus') getAccountStatus: any;

  private lastLesson: any = null;

  private quickClassInfo: any = null;

  get allowAccess(): boolean {
    return (
      this.getAccountStatus === 2 || this.getAccountStatus === 4 || this.getAccountStatus === 5
    );
  }

  private trimAll(val: string): string {
    return val.replace(/\s/g, '');
  }

  // 处理“快速上课”按钮逻辑
  private handleGoShouKe(quickClassInfo: any) {
    // 用于新项目跳转未重构的老项目增加头部地址
    const jumpurl = process.env.VUE_APP_JUMPURL;
    const url = `${jumpurl}/shouke.html#/?
      classId=${quickClassInfo.classDetail.classId}&
      lessonId=${quickClassInfo.lesson.id}&
      num=${quickClassInfo.lesson.num}&
      model=kejian&newDiyFlag=${quickClassInfo.newDiyFlag}`;
    window.open(this.trimAll(url));
  }

  // 处理最近备课记录
  private handleGoBeiKe(lastLesson: any) {
    let url;
    // 用于新项目跳转未重构的老项目增加头部地址
    const jumpurl = process.env.VUE_APP_JUMPURL;
    setTimeout(() => {
      const { lessonId: id, lessonName: name } = lastLesson;
      this.$track.sendClickLog(TrackeData.PRELESSONS_CONTINUE_CLICK, { id, name });
    }, 500);
    if (lastLesson.style === 4) {
      url = `${jumpurl}/courseInfo.html#/?
        lessonId=${lastLesson.lessonId}&
        classTypeId=${lastLesson.classTypeTypeId}&
        subjectId=${lastLesson.subjectId}&
        businessId=${lastLesson.classId ? lastLesson.classId : lastLesson.classTypeTypeId}&
        businessType=${lastLesson.classId ? 1 : 2}&newDiyFlag=${lastLesson.newDiyFlag}`;
      window.open(this.trimAll(url));
    } else {
      url = `//bk.aixuexi.com/#/index/courseInfo?
        lessonId=${lastLesson.lessonId}&
        classTypeId=${lastLesson.classTypeTypeId}&
        subjectId=${lastLesson.subjectId}&
        styleClass=${lastLesson.style}&newDiyFlag=${lastLesson.newDiyFlag}`;
      window.open(this.trimAll(url));
    }
  }

  // 获取上次备课记录
  private getLastLesson() {
    this.$service.bk.getLastLesson().then((result: any) => {
      this.lastLesson = this.$lodash.isEmpty(result) ? null : result;
    });
  }

  private getFastClass() {
    this.$service.bk.getFastClass().then((result: any) => {
      this.quickClassInfo = this.$lodash.isEmpty(result) ? null : result;
    });
  }

  mounted() {
    // 上次备课记录
    this.getLastLesson();
    // 快速上课
    if (!this.allowAccess) {
      this.getFastClass();
    }
  }
}
